{
  "greeting": {
    "salam": "Assalamu alaikum",
    "salamWithName": "Assalamu alaikum, {{name}}"
  },
  "dock": {
    "saved": "Guardado",
    "savedVerses": "Versículos guardados",
    "tasks": "Tareas",
    "notes": "Notas"
  },
  "actions": {
    "save": "Guardar",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "delete": "Eliminar",
    "rename": "Renombrar",
    "dismiss": "Descartar",
    "loading": "Cargando…",
    "reload": "Recargar",
    "retry": "Reintentar",
    "expand": "Expandir",
    "collapse": "Contraer"
  },
  "nav": {
    "appNavigation_aria": "Navegación de la app"
  },
  "tabs": {
    "home": "Inicio",
    "tasks": "Tareas",
    "notes": "Notas",
    "more": "Más"
  },
  "more": {
    "daily": "Diario",
    "account": "Cuenta",
    "savedVerses": "Versículos guardados",
    "qibla": "Qibla",
    "prayerTimes": "Horarios de oración y recordatorios",
    "rhemnPro": "Rhemn Pro",
    "proManagedViaAccount": "Se gestiona a través de tu cuenta de Rhemn",
    "upgrade": "Mejorar",
    "privacyPolicy": "Política de privacidad",
    "version": "Rhemn · v{{version}}",
    "back_aria": "Atrás",
    "deleteAccount": "Eliminar cuenta"
  },
  "reflection": {
    "dismiss_aria": "Descartar reflexión"
  },
  "app": {
    "loading_aria": "Rhemn se está cargando",
    "logo_alt": "Rhemn",
    "safariManageOnWeb": "Gestiona tu suscripción Rhemn Pro en la web. Pro se desbloquea automáticamente aquí cuando inicias sesión con tu cuenta suscrita."
  },
  "header": {
    "qiblaDirection_aria": "Dirección de la Qibla",
    "prayerTimes_aria": "Horarios de oración",
    "prayerTimesTitle": "Horarios de oración",
    "method": "Método",
    "methodHelp": "El método afecta los horarios calculados"
  },
  "search": {
    "search_aria": "Buscar",
    "searchLabel": "Buscar",
    "searchWeb_placeholder": "Buscar en la web"
  },
  "focus": {
    "input_placeholder": "¿Qué importa más hoy?",
    "example_worship": "Rezar con presencia, sin prisa",
    "example_kindness": "Llamar a mi madre solo para escucharla",
    "example_reflect": "Reflexiona sobre tu intención con la aleya de hoy",
    "saveIntention_aria": "Guardar intención",
    "celebration": "🤲 Mashalla"
  },
  "profile": {
    "profileFallback": "Perfil",
    "profileAndAccount_aria": "Perfil y cuenta",
    "profileDialog_aria": "Perfil",
    "editName_aria": "Editar tu nombre",
    "logo_alt": "Rehmn",
    "proBadge": "PRO",
    "manageSubscription": "Gestionar suscripción",
    "manageSubscription_aria": "Gestiona tu suscripción Rehmn Pro",
    "anonymousAnalytics": "Análisis anónimos",
    "anonymousAnalyticsNote": "Solo agregados — nunca vinculados a ti",
    "shareAnalytics_aria": "Compartir análisis de uso anónimos",
    "signOut": "Cerrar sesión",
    "signingOut": "Cerrando sesión…",
    "signOut_aria": "Cerrar sesión de Rehmn",
    "restorePurchases": "Restaurar compras",
    "restorePurchases_aria": "Restaurar compras anteriores"
  },
  "background": {
    "loading": "Cargando fondo...",
    "fallbackNotice": "Usando imagen de reserva (API de Unsplash no disponible)",
    "noImage": "No hay imagen de fondo disponible",
    "error": "Error: {{message}}",
    "photoByOnUnsplash": "Foto de <photographer>{{name}}</photographer> en <unsplash>Unsplash</unsplash>"
  },
  "error": {
    "title": "Algo salió mal",
    "fallbackMessage": "Ocurrió un error inesperado."
  },
  "theme": {
    "switchToLight_title": "Cambiar a modo claro",
    "switchToDark_title": "Cambiar a modo oscuro"
  },
  "upgradeCta": {
    "upgradeToPro": "Mejorar a Pro",
    "restorePurchases": "Restaurar compras",
    "restoring": "Restaurando…",
    "restoreEmpty": "No se encontraron compras.",
    "pricePerMonth": "{{price}} / mes",
    "pricePerYear": "{{price}} / año",
    "purchasePending": "Esperando aprobación. Pro se activará automáticamente cuando se apruebe la compra.",
    "storeUnavailable": "No se puede acceder al App Store en este momento. Inténtalo de nuevo en un momento.",
    "purchaseFailed": "No se pudo completar la compra. Inténtalo de nuevo en un momento."
  },
  "upgradeCard": {
    "eyebrow": "Rhemn Pro · 25 % de descuento el primer año",
    "title": "Para las horas entre tus oraciones.",
    "body": "Notas de voz que se transcriben, se resumen y se convierten en tareas. Un planificador del día construido en torno a tus horarios de oración. Notas con IA.",
    "price": "$29.99",
    "period": "por tu primer año",
    "priceIos": "25 % de descuento el primer año",
    "terms": "Después, $39.99 al año. El código {{code}} ya está aplicado.",
    "termsIos": "Se renueva al precio anual habitual. Usa el código {{code}} en el App Store.",
    "free": "Los horarios de oración, la Qibla, el versículo del día y las tareas siguen siendo gratis.",
    "cta": "Mejorar a Pro",
    "dismiss": "Ahora no"
  },
  "planChooser": {
    "monthly": "Mensual",
    "yearly": "Anual",
    "yearlyValue": "Cuatro meses por nuestra cuenta.",
    "freeNote": "Los horarios de oración, la Qibla, el versículo del día y las tareas son gratis. Rhemn Pro añade:",
    "includes_planner": "Un día organizado en torno a las cinco oraciones, y «Planificar mi día»",
    "includes_insights": "Quran Insights: pregunta lo que quieras sobre un versículo y lee su contexto",
    "includes_reflections": "Reflexiones del versículo del día, escritas para la intención que fijaste",
    "includes_notes": "Notas y notas de voz, con resúmenes y limpieza por IA",
    "includes_extras": "Versículos guardados, tarjetas de versículo, rachas y pronóstico de 5 días",
    "renewsMonthly": "Se renueva cada mes hasta que lo canceles",
    "renewsYearly": "Se renueva cada 12 meses hasta que lo canceles",
    "continue": "Continuar",
    "renewalTerms": "El pago se carga a tu Apple ID al confirmar. La suscripción se renueva automáticamente salvo que desactives la renovación automática al menos 24 horas antes de que termine el periodo. Gestiónala o cancélala cuando quieras en los ajustes de Apple ID.",
    "retry": "Reintentar"
  },
  "streak": {
    "badge_aria": "Racha diaria — {{count}} días",
    "title": "Racha diaria",
    "daysWithCount": "Racha de {{count}} días",
    "start": "Comienza hoy — dedica un momento al versículo o marca una oración.",
    "prayedToday": "Oré hoy",
    "readVerse": "Leí el versículo de hoy",
    "autoHint": "El versículo se marca solo cuando le dedicas un momento.",
    "milestoneTitle": "{{count}} días de intención",
    "milestoneBody": "Alhamdulillah. Comparte este logro — alguien que quieres también podría comenzar.",
    "share": "Compartir",
    "dismiss": "Ahora no",
    "cardLabel": "días de intención",
    "shareCaption": "{{count}} días comenzando con intención — rhemn.com",
    "imageSaved": "Imagen guardada.",
    "couldNotCreateImage": "No se pudo crear la imagen. Inténtalo de nuevo."
  },
  "qibla": {
    "compassIcon_aria": "Icono de brújula",
    "title": "Dirección de la Qibla",
    "locationUnavailable": "Ubicación no disponible",
    "locating": "Localizando…",
    "compass_aria": "Brújula de la Qibla",
    "directionN": "N",
    "directionE": "E",
    "directionS": "S",
    "directionW": "O",
    "facingQibla": "Frente a la Qibla",
    "enableLiveCompass": "Activar brújula en vivo",
    "enableLiveCompassNote": "Usa el sensor de movimiento para que la flecha te siga al girar — no la ubicación",
    "directionToMecca": "Dirección a La Meca",
    "enableLocation": "Activa el acceso a la ubicación para calcular la dirección",
    "hintLive": "La flecha sigue la orientación de tu dispositivo en tiempo real",
    "hintStatic": "Rumbo desde el Norte — úsalo con una brújula para una dirección precisa",
    "live": "En vivo",
    "footerVerse": "\"Así que vuelve tu rostro hacia la Mezquita Sagrada\" – Quran 2:144"
  },
  "legal": {
    "links_aria": "Legal",
    "termsOfUse": "Condiciones de uso",
    "privacyPolicy": "Política de privacidad"
  },
  "auth": {
    "signInForPro": "Inicia sesión primero: tu Pro te acompaña a todas partes."
  },
  "integrations": {
    "row": {
      "label": "Calendarios y tareas",
      "caption": "Conectado",
      "subNone": "No conectado",
      "subFree": "Google Calendar, Google Tasks y más",
      "subAttention": "{{provider}} necesita atención",
      "subPaused": "Sincronización en pausa"
    },
    "list": {
      "title": "Calendarios y tareas",
      "subtitle": "Trae tus reuniones y pendientes a tu día.",
      "footnote": "Rhemn solo lee lo que necesita y nunca almacena tus eventos.",
      "privacy": "Política de privacidad",
      "connect": "Conectar",
      "connect_aria": "Conectar {{what}}",
      "checking": "Comprobando…",
      "loadError": "No se pudieron cargar tus conexiones.",
      "tryAgain": "Inténtalo de nuevo",
      "offline": "Estás sin conexión. Conéctate cuando vuelvas a estar en línea.",
      "unavailable": "Calendarios y tareas no están disponibles en este momento.",
      "disconnected": "{{provider}} desconectado.",
      "google": {
        "name": "Google",
        "sub": "Calendar y Tasks",
        "what": "Google Calendar y Tasks"
      },
      "todoist": {
        "name": "Todoist",
        "sub": "Tareas y proyectos",
        "what": "Todoist"
      },
      "apple": {
        "name": "Calendario y Recordatorios",
        "subNative": "En este {{device}}",
        "subSafari": "En la app de Rhemn para iPhone y Mac"
      },
      "synced": "Sincronizado {{when}}",
      "connectedSub": "Conectado",
      "syncing": "Sincronizando…",
      "reconnectSub": "Vuelve a conectar para seguir sincronizando",
      "errorSub": "La última sincronización no terminó",
      "pausedSub": "En pausa · Rhemn Pro terminó"
    },
    "explainer": {
      "google": {
        "title": "Conecta Google Calendar y Tasks",
        "p1Lead": "Tu calendario, de solo lectura",
        "p1Body": "Rhemn muestra tus eventos en tu día y ve cuándo estás ocupado. No los almacena.",
        "p2Lead": "Google Tasks, en ambas direcciones",
        "p2Body": "Las listas que elijas se mantienen sincronizadas, para que puedas marcarlas donde sea.",
        "p3Lead": "Tú decides cuándo deshacerlo",
        "p3Body": "Desconecta cuando quieras, aquí o en tu cuenta de Google.",
        "footnote": "Google te mostrará exactamente lo que Rhemn está solicitando."
      },
      "todoist": {
        "title": "Conecta Todoist",
        "p1Lead": "Tus proyectos, en ambas direcciones",
        "p1Body": "Los proyectos que elijas se mantienen sincronizados, para que puedas marcarlos donde sea.",
        "p2Lead": "Cómo se corresponden",
        "p2Body": "Las prioridades de Todoist se convierten en Crítica, Alta, Media y Baja. Las subtareas de más de un nivel aparecen como pasos bajo su tarea principal.",
        "p3Lead": "Tú decides cuándo deshacerlo",
        "p3Body": "Desconecta cuando quieras, aquí o en los ajustes de Todoist.",
        "cta": "Continuar a Todoist",
        "footnote": "Todoist te pedirá que confirmes."
      },
      "skip": "Ahora no",
      "cancel": "Cancelar",
      "waiting": "Esperando a {{provider}}…",
      "safariWaiting": "Termina en la nueva pestaña y luego vuelve aquí.",
      "safariReopen": "Abrir la pestaña de nuevo",
      "denied": "{{provider}} no concedió acceso, así que no se conectó nada.",
      "error": "No se pudo conectar con {{provider}}. Inténtalo de nuevo en un momento."
    },
    "detail": {
      "back_aria": "Volver a Calendarios y tareas",
      "syncNow": "Sincronizar ahora",
      "intro": "Elige qué sincroniza Rhemn. Puedes cambiarlo cuando quieras.",
      "taskLists": "Listas de tareas",
      "projects": "Proyectos",
      "reminders": "Recordatorios",
      "calendars": "Calendarios",
      "rhemnCalendarSub": "Tus horarios de oración, no cuentan como ocupado",
      "loading": "Cargando…",
      "loadError": "No se pudieron cargar tus listas.",
      "emptyGoogle": "No hay listas de tareas en Google Tasks.",
      "emptyTodoist": "No hay proyectos en Todoist.",
      "addError": "No se pudo añadir {{name}}. Inténtalo de nuevo.",
      "removed": "Eliminado de Rhemn. Sigue en {{provider}}.",
      "undo": "Deshacer",
      "prayerTimes": "Añade los horarios de oración a tu calendario",
      "prayerTimesSub": "Añade las cinco oraciones a un calendario llamado Rhemn, para los próximos 7 días, para que nadie reserve encima.",
      "prayerTimesOn": "Activado. Añadido hasta el {{date}}.",
      "prayerTimesWaiting": "Esperando a Google…",
      "prayerTimesDenied": "Google no lo permitió. No se añadió nada.",
      "prayerTimesRemoveAsk": "¿Quitar los horarios de oración de Rhemn de tu calendario?",
      "prayerTimesKeep": "Mantenerlos",
      "prayerTimesRemove": "Quitar",
      "meetingPrompts": "Avisos de reuniones",
      "meetingPromptsSub": "Cuando una reunión con un enlace está por empezar, ofrece tomar notas.",
      "busyFootnote": "«Planificar mi día» solo ve cuándo estás ocupado, nunca de qué tratan tus reuniones.",
      "todoistFootnote": "Las prioridades de Todoist se convierten en Crítica, Alta, Media y Baja. Las subtareas de más de un nivel aparecen como pasos bajo su tarea principal.",
      "reauth": "{{provider}} dejó de permitir que Rhemn sincronice. Esto ocurre cuando se revoca el acceso o cambia tu contraseña.",
      "reconnect": "Reconectar",
      "paused": "La sincronización está en pausa porque Rhemn Pro terminó. Tus listas se mantienen como estaban.",
      "calendarDenied": "El acceso al calendario está desactivado.",
      "remindersDenied": "El acceso a recordatorios está desactivado.",
      "disconnect": "Desconectar {{provider}}",
      "disconnectTitle": "¿Desconectar {{provider}}?",
      "disconnectBody": "No se elimina nada en {{provider}}.",
      "disconnectRhemnCal": "Tu calendario de horarios de oración de Rhemn se eliminará de Google Calendar.",
      "disconnectError": "No se pudo desconectar {{provider}}. Inténtalo de nuevo en un momento.",
      "keepLists": "Mantener mis listas en Rhemn",
      "keepListsSub": "Dejan de sincronizarse y pasan a ser listas normales de Rhemn.",
      "removeLists": "Quitarlas de Rhemn",
      "removeListsSub": "Solo se eliminan las copias en Rhemn.",
      "disconnecting": "Desconectando…",
      "appleStop": "Dejar de usar Calendario y Recordatorios",
      "appleStopTitle": "¿Dejar de usar Calendario y Recordatorios?",
      "appleStopBody": "Rhemn deja de mostrar tus eventos y recordatorios. Para eliminar por completo su acceso, desactívalo en Ajustes.",
      "justNow": "justo ahora",
      "tasksScope": "Rhemn necesita permiso para ver tus Google Tasks. Vuelve a conectar y marca Tareas para permitirlo.",
      "calendarsLoadError": "No se pudieron cargar tus calendarios.",
      "calendarsEmpty": "No hay calendarios en esta cuenta.",
      "calendarsScope": "Rhemn necesita permiso para ver tu Google Calendar. Vuelve a conectar y marca Calendar para permitirlo.",
      "prayerTimesError": "No se pudieron añadir tus horarios de oración. Inténtalo de nuevo en un momento.",
      "remindersEmpty": "No hay listas en Recordatorios.",
      "openSettings": "Abrir Ajustes",
      "appleStopCta": "Dejar de usar"
    },
    "locked": {
      "body": "Ve tus reuniones dentro de tus bloques de oración y mantén Google Tasks sincronizado con Rhemn.",
      "googleName": "Google Calendar y Tasks"
    },
    "device": {
      "phone": "iPhone",
      "pad": "iPad",
      "mac": "Mac",
      "fallback": "dispositivo"
    },
    "tasks": {
      "syncedWith_aria": "{{list}}, sincronizada con {{provider}}",
      "unlinkConfirm": "¿Quitar «{{name}}» de Rhemn? Seguirá en {{provider}}.",
      "remove": "Quitar",
      "offline": "Sin conexión · Los cambios se sincronizarán con {{provider}} cuando vuelvas.",
      "stillSyncing": "Aún sincronizando con {{provider}}…",
      "failed_one": "{{count}} cambio no llegó a {{provider}}.",
      "failed_many": "{{count}} cambios no llegaron a {{provider}}.",
      "failed_other": "{{count}} cambios no llegaron a {{provider}}.",
      "retry": "Reintentar",
      "needsReconnect": "{{provider}} necesita que vuelvas a conectar.",
      "paused": "La sincronización está en pausa · Rhemn Pro terminó.",
      "upgrade": "Mejorar",
      "notSynced": "Sin sincronizar",
      "notSynced_aria": "Sin sincronizar con {{provider}}. Reintentar.",
      "remindersOff": "Rhemn no puede acceder a Recordatorios. Actívalo de nuevo en Ajustes.",
      "dueToday": "Hoy",
      "dueTomorrow": "Mañana",
      "googleTasks": "Google Tasks"
    },
    "today": {
      "allDay": "Todo el día",
      "more": "+{{count}}",
      "more_aria": "Mostrar {{count}} eventos más de todo el día",
      "less_aria": "Mostrar menos eventos de todo el día",
      "events_aria": "Eventos",
      "event_aria": "De {{start}} a {{end}}, {{title}}",
      "allDayEvent_aria": "Todo el día, {{title}}",
      "untitled": "Ocupado",
      "now": "Ahora · hasta las {{end}}",
      "until": "hasta las {{end}}",
      "into": "· hasta {{prayer}}",
      "loadError": "No se pudo cargar tu calendario.",
      "needsReconnect": "Google Calendar necesita que vuelvas a conectar.",
      "scope": "Rhemn no puede ver tu Google Calendar. Vuelve a conectar y marca Calendar para permitirlo.",
      "appleOff": "Rhemn no puede ver tu calendario. Vuelve a activarlo en Ajustes."
    },
    "plan": {
      "mostlyMeetings": "Casi todo reuniones · {{duration}} libres",
      "noFreeTime": "Sin tiempo libre",
      "aroundMeetings_one": "Planificado en torno a {{count}} reunión.",
      "aroundMeetings_many": "Planificado en torno a {{count}} reuniones.",
      "aroundMeetings_other": "Planificado en torno a {{count}} reuniones.",
      "settledBusy": "Todo ya encaja en torno a tus reuniones."
    },
    "meeting": {
      "group_aria": "Reunión a punto de empezar",
      "now": "ahora",
      "takeNotes": "Tomar notas",
      "takeNotes_aria": "Tomar notas de {{title}}",
      "dismiss_aria": "Descartar",
      "announce": "{{title}} empieza {{when}}.",
      "announceNow": "{{title}} está empezando.",
      "yourMeeting": "Tu reunión"
    },
    "apple": {
      "primer": {
        "title": "Muestra tu calendario junto a tus oraciones",
        "body": "Rhemn lee los eventos y recordatorios de este {{device}} para situarlos en tu día. Se quedan en tu dispositivo. Planificar mi día solo usa las horas en que estás ocupado.",
        "cta": "Continuar",
        "skip": "Ahora no",
        "footnote": "{{device}} preguntará dos veces, una para Calendario y otra para Recordatorios. Puedes cambiar cualquiera en Ajustes."
      }
    }
  }
}
